import { LitElement, html } from "lit";

import { customElement } from "lit/decorators.js";

import "ui-components/error-page";
import { t } from "../translations/i18n";

@customElement("wow-404")
export class WowPage404 extends LitElement {
  protected override render() {
    return html`
      <wow-error-page
        errorCode="404"
        title=${t("pages.pageNotFound")}
        message=${t("pages.notFoundMessage")}
        buttonText="Go Home"
        buttonHref="/profile"
      ></wow-error-page>
    `;
  }
}
